export default __webpack_public_path__ + "static/media/videos.9e555933.svg";